export const getSystemAvatar = (color: string) => {
	// tslint:disable-next-line:max-line-length
	const avatarString = `<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23"><g fill="${color}" fill-rule="evenodd"><path d="M11.5 23C5.149 23 0 17.851 0 11.5S5.149 0 11.5 0 23 5.149 23 11.5 17.851 23 11.5 23zm0-3a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17z"/><circle cx="14.5" cy="10.5" r="1.5"/><circle cx="8.5" cy="10.5" r="1.5"/></g></svg>`;
	const base64Avatar = btoa(avatarString);
	const avatarUrl = `data:image/svg+xml;base64,${base64Avatar}`;
	return avatarUrl;
};
